import { Button } from "@features/atoms/Button"
import { Input } from "@features/atoms/Input"
import { Appear } from "@features/motion/Appear"
import { cn } from "@utils/tw"
import { defineBlock, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Newsletter Inner",
}

export default defineBlock("forms/newsletter-inner", (props) => {
  return (
    <Appear
      className={cn(
        "newsletter-inner p-5 w-full shrink-0 flex flex-col items-start justify-between gap-8 [&_h2]:type-title-l [&_h2]:!my-0 [&_p]:!my-0",
        !env.admin && "md:w-[64%]",
      )}
    >
      <InnerBlocks
        allowedBlocks={["#inline"]}
        defaultBlocks={[
          ["core/paragraph", { className: "is-style-label-small", placeholder: "Newsletter", content: "Newsletter" }],
          [
            "core/paragraph",
            {
              className: "is-style-body-large",
              placeholder: "Stay on top of our new releases",
              content: "Stay on top of our new releases",
            },
          ],
        ]}
        className="w-full md:w-[80%] flex flex-col gap-3 items-start justify-center"
      />

      <div className="flex flex-nowrap items-center gap-2">
        <Input
          name="email"
          placeholder="Email"
          type="email"
          className="!bg-white !text-blue-light"
          inputClassName="!border-none"
        />
        <Button variant="link" className="!text-white border border-white !no-underline !h-7">
          Sign Up
        </Button>
      </div>
    </Appear>
  )
})
